var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { Odd } from "./odd";
import { mobileHighLightedMarket, myHighLightedMarketGroups } from "../../../services/sportsbook.services";
import { highLightedMarketCategories } from "../../../definitions/constants/market-categories.constant";
import { EventMarket } from "../../../models/sportsbook.model";
import { isMobileView } from "../../../app";
// 5518 - 5520
export function HighlightedMarkets(props) {
    // fixme: re-render edilmesede bu kısım sürekli çalıştırılıyor gibi kontrol et
    var highlightedMarkets = props.highlightedMarkets;
    var event = props.event;
    var sportKey = "".concat(event.sS).concat(window.location.href.includes('canli') ? '-canli' : '');
    var allCategories = highLightedMarketCategories[sportKey] || highLightedMarketCategories[event.sS] || [];
    var row2Markets = allCategories.filter(function (m) { return m.row === 2; });
    var hlGroups = [];
    try {
        hlGroups = myHighLightedMarketGroups[sportKey] || myHighLightedMarketGroups[event.sS] || [];
    }
    catch (e) {
        hlGroups = myHighLightedMarketGroups[event.sS] || [];
    }
    if (isMobileView) {
        try {
            hlGroups = mobileHighLightedMarket[sportKey] || mobileHighLightedMarket[event.sS] || [];
        }
        catch (e) {
            hlGroups = mobileHighLightedMarket[event.sS] || [];
        }
    }
    var hasSecondRow = row2Markets.length > 0;
    var bpKey = Number(event.bP) === 0 ? 'pre' : 'live';
    var findRow2Market = function (h) {
        return row2Markets.find(function (r2) {
            return String(r2.halfTimeOf) === String(h.pre) || String(r2.halfTimeOf) === String(h.live);
        });
    };
    if (isMobileView) {
        return highlightedMarkets ? (_jsxs(_Fragment, { children: [_jsx(React.Fragment, { children: hlGroups.map(function (h, key) {
                        var _market = highlightedMarkets[h[bpKey]];
                        return (_jsx(React.Fragment, { children: _jsx(Odd, { event: event, market: _market, hlGroup: h }, "odd-" + key) }, "highlightedMarkets-" + key));
                    }) }, void 0), hasSecondRow && (_jsxs("div", __assign({ className: "mobile-markets-ht-row" }, { children: [_jsx("span", __assign({ className: "mobile-ht-label" }, { children: "1HT" }), void 0), hlGroups.map(function (h, key) {
                            var h2 = findRow2Market(h);
                            if (!h2)
                                return null;
                            var _market = highlightedMarkets[h2[bpKey]];
                            return (_jsx(React.Fragment, { children: _jsx(Odd, { event: event, market: _market, hlGroup: h2 }, "odd-row2-" + key) }, "highlightedMarketsRow2-" + key));
                        })] }), void 0))] }, void 0)) : (_jsx(_Fragment, {}, void 0));
    }
    else {
        return highlightedMarkets ? (_jsxs(React.Fragment, { children: [_jsx("div", __assign({ className: "markets-row" }, { children: hlGroups.map(function (h, key) {
                        var _market = highlightedMarkets[h[bpKey]];
                        return (_jsxs(React.Fragment, { children: [key !== 0 &&
                                    _jsx("div", __assign({ className: "multi-column-base" }, { children: _market && (_market.sOV ? _market.sOV : (_market.pS ? _market.pS : '')) }), void 0), _jsx("div", __assign({ className: "market-cell" }, { children: _jsx(Odd, { event: event, market: _market, hlGroup: h }, void 0) }), void 0)] }, "r1-" + key));
                    }) }), void 0), hasSecondRow && (_jsxs("div", __assign({ className: "markets-row" }, { children: [_jsx("div", __assign({ className: "markets-row-ht" }, { children: "1HT" }), void 0), hlGroups.map(function (h, key) {
                            var h2 = findRow2Market(h);
                            var _market2 = h2 ? highlightedMarkets[h2[bpKey]] : undefined;
                            return (_jsxs(React.Fragment, { children: [key !== 0 &&
                                        _jsx("div", __assign({ className: "multi-column-base" }, { children: _market2 && (_market2.sOV ? _market2.sOV : (_market2.pS ? _market2.pS : '')) }), void 0), _jsx("div", __assign({ className: "market-cell" }, { children: h2
                                            ? _jsx(Odd, { event: event, market: _market2, hlGroup: h2 }, void 0)
                                            : _jsx("div", { className: "market-bc-placeholder" }, void 0) }), void 0)] }, "r2-" + key));
                        })] }), void 0))] }, void 0)) : (_jsx(_Fragment, {}, void 0));
    }
}
export function HighlightedMarketsCard(props) {
    var highlightedMarkets = props.highlightedMarkets;
    var event = props.event;
    var selectedMarket = new EventMarket();
    // @ts-ignore
    for (var _i = 0, _a = Object.entries(highlightedMarkets); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], val = _b[1];
        var ma = highlightedMarkets[key];
        if (ma.mS < 2 && ma.mS !== 0) {
            selectedMarket = ma;
            break;
        }
    }
    return selectedMarket.marketId ? (_jsx("div", __assign({ className: "market-group-holder-bc ext-44" }, { children: _jsx(Odd, { event: event, showOutcomeNameIn: true, showOutcomeName: true, market: selectedMarket, marketOutcome: selectedMarket.marketOutcome }, void 0) }), "HighlightedMarketsCard-1")) : (_jsx(_Fragment, {}, void 0));
}
